export default {
  saltUnit: null,
  drinkUnit: null,
  smokeUnit: null,
  exerciseUnit: null,
  __typename: 'LivingHabits'
};
